import React from 'react';
import { useSelector } from 'react-redux';

import { FullScreenLoading } from 'components/Loading';
import OperatorAuthOverlay from 'components/OperatorAuthOverlay';
import {
  getIsBaseAppDataLoading,
  getBaseAppDataLoadingStates,
} from 'lib/selectors/getIsBaseAppDataLoading';

const PendingStates = ({ children }) => {
  const isBaseAppDataLoading = useSelector(getIsBaseAppDataLoading);
  const baseAppDataLoadingStates = useSelector(getBaseAppDataLoadingStates);

  return (
    <>
      {isBaseAppDataLoading && (
        <FullScreenLoading loadingStates={baseAppDataLoadingStates} />
      )}
      <OperatorAuthOverlay />
      {children}
    </>
  );
};

export { PendingStates };
